var _rect, _path, _rect2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcPenFilled = function SvgIcPenFilled(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#DB147F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8047 21.1378L19.4697 15.4728C19.7626 15.1799 19.7626 14.705 19.4697 14.4121L17.5877 12.5301C17.2948 12.2372 16.8199 12.2372 16.527 12.5301L10.862 18.1951C10.7767 18.2805 10.7161 18.3874 10.6867 18.5044L10.4306 19.8081C10.2251 20.8541 11.1456 21.7747 12.1916 21.5691L13.4947 21.3131C13.612 21.2838 13.7193 21.2231 13.8047 21.1378ZM22 12.9424C22.25 12.6924 22.3904 12.3533 22.3904 11.9998C22.3904 11.6462 22.25 11.3071 22 11.0571L20.9427 9.99976C20.6926 9.7498 20.3536 9.60938 20 9.60938C19.6464 9.60938 19.3074 9.7498 19.0573 9.99976L18.5303 10.5268C18.2374 10.8197 18.2374 11.2945 18.5303 11.5874L20.4123 13.4694C20.7052 13.7623 21.1801 13.7623 21.473 13.4694L22 12.9424Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#DB147F"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcPenFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-pen-filled.34d59c73.svg";
export { ForwardRef as ReactComponent };